import React,{useState,useEffect} from 'react'
import AppHeader from '../../../components/AppHeader'
import OTPLoginPage from '../../../components/OTPLoginPage';
import portalServices from '../../../portalServices';
import { Link, useNavigate } from 'react-router-dom';
import AppFooter from '../../../components/AppFooter';

function CustomerProfileListPage() {

    const navigate = useNavigate()
    const [customerToken,setCustomerToken] =  useState(localStorage.customerToken);
    const [customerList,setCustomerList] = useState(null);

    const getCustomerList = () => {
        let payload = {
            customerToken:customerToken
        }
        portalServices.getCustomerProfileList(payload).then(res=>{
            setCustomerList(res.data);

            if(res.data.length == 1){
                navigate("/consultancy-list/"+res.data[0].id);
            }

            }).catch(error=>{

            })
        }

    useEffect(()=>{
        if(customerToken){
            getCustomerList();
        }
    },[customerToken])


  return (
        <>
            <AppHeader/>
            <div className='container'>
                {
                    (customerToken === null || customerToken === undefined)?
                        <OTPLoginPage
                        setCustomerToken={setCustomerToken}
                        /> 
                    :
                    <div className='row mt-4'>
                        <div className='col-md-12'><h5 className='fw-bold'>Select Patient Profile</h5></div>
                        <div className='col-md-12'>
                            {customerList && customerList.map(customer=>
                                <Link to={"/consultancy-list/"+customer.id} className='btn btn-outline-primary me-3'  > {customer.firstName}</Link>
                            )}
                        </div>
                    </div>
                }

            </div>
            <AppFooter/>
        </>
    )
}

export default CustomerProfileListPage